<template>
  <div
    class="map-pin"
    :class="{ 
      [location.location_type]: true,
      'is-active': isActive,
      'is-hovered': isHovered 
    }"
    :style="{
      transform: `
        translate(${(location.coords_x - minX) / scale + offset.x - 12}px, ${
        (location.coords_y - minY) / scale + offset.y - 12
      }px)
      `
    }"
    @click="followLink"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <div v-html="pins[location.location_type]"></div>
    <div v-show="isHovered" class="popup">
      <p class="title">
        {{ location.title }}
      </p>
      <p class="type">
        {{ humanizeType(location.location_type) }} 
      </p>
    </div>
  </div>
</template>

<script>
import * as Pins from '../pins';
import * as LargePins from '../large-pins';

export default {
  name: 'Pin',

  props: {
    location: {
      type: Object,
      required: true,
    },
    scale: {
      type: Number,
      required: true,
    },
    offset: {
      type: Object,
      required: true,
    },
    minX: {
      type: Number,
      default: 0,
    },
    minY: {
      type: Number,
      default: 0,
    },
    activeLocationId: {
      type: [Number, String, null],
      default: null,
    },
  },

  data() {
    return {
      isHovered: false,
    };
  },

  computed: {
    isActive() {
      return this.location.id === this.activeLocationId;
    },

    pins () {
      return this.isActive ? LargePins : Pins;
    },
    svg() {
      return this.$refs.map.$el;
    },

    wrapper() {
      return this.$refs.mapWrapper;
    },
  },

  methods: {
    humanizeType(typeString) {
      if (!typeString) return '';

      const spaced = typeString.replace(/_/g, ' ');

      return spaced.replace(/\b\w/g, (char) => char.toUpperCase());
    },
    followLink() {
      if (this.location.slug) {
        window.location.href = `/location/${this.location.slug}`;
      }
    },
  }
};
</script>

<style lang="scss">
.map-pin {
  @apply hover:cursor-pointer;

  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  z-index: 50;

  &.is-hovered {
    z-index: 100 !important;
  }

  &.is-active {
    pointer-events: none;
    rect {
      // fill: #ffd647;
    }
  }
}
.map-pin.jewish_ghettos {
  pointer-events: none;
}

.map-pin.extermination_camp:hover {
  rect {
    fill: #ffd647;
  }
}

.map-pin.transit_ghettos:hover {
  path,
  svg {
    fill: #ffd647;
  }
}

.popup {
  position: absolute;
  top: -285%;
  left: 125%;
  padding: 8px 8px 8px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-left: 4px solid #ffd647;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  white-space: nowrap;
  pointer-events: none;

  .title {
    color: #000;
    font-family: Merriweather;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }

  .type {
    color: rgba(0, 0, 0, 0.6);
    font-family: Merriweather;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
}
</style>
